<template>
  <div
    id="trustBadge"
    :class="[$style['trustbadge'],
             {[$style['trustbadge--sticky-active']] : stickyActive}]"
    :style="{
      'pointer-events': $lang == 'de' ? null : 'none'
    }" />
</template>
<script setup>
const { $lang } = useNuxtApp()
const { stickyActive } = useStickOnScroll()

stickyActive.value = false

</script>
<style lang="scss" module>
.trustbadge {
  position: fixed;
  margin: var(--spacing);
  bottom: 0;
  width: 160px;
  height: 80px;
  z-index: calc(var(--z-index-category-navigation) - 1);
  transition: .4s;

  &--sticky-active {
    bottom: 6rem;
  }

  @media (min-width: #{$breakpoint-tablet}) {
    right: 0;

    &--sticky-active {
      bottom: 5.4rem;
    }
  }

}

</style>
